import React, { useState } from "react";
import logoImg from "../assets/Logo.jpeg";
import { Link } from "react-router-dom";
import '../styles/ISBRsvp.css';

export default function ISBRsvp() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    attending: "",
    guests: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");


    // Two separate access keys — one per target email.
    // Each key sends to the email it was registered with.
    const accessKeys = [
      "8d28f9a2-c2e5-4aab-bb39-bf36ce45eda3",       // registered with eshantripathi005@gmail.com
      "fd740bd8-5bae-433e-8f87-86a0ea387846",       // registered with mysterymansion.in@gmail.com
    ];

    const commonPayload = {
      subject: `Mystery Mansion RSVP — ${formData.name}`,
      from_name: "Mystery Mansion RSVP",
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      "Will be attending": formData.attending,
      "Number of guests": formData.guests,
    };

    try {
      // Send to Google Sheets via GET with query params (most reliable for GAS)
      const sheetsUrl = "https://script.google.com/macros/s/AKfycbw7lLDMKwiEmcDTsD00a9lPl1EvI_s8yKCs41WaufVHh7XjuHYBmuZzxxMSXuL_eT3J/exec";
      try {
        const params = new URLSearchParams({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          attending: formData.attending,
          guests: formData.guests || "",
        });
        await fetch(`${sheetsUrl}?${params.toString()}`, { mode: "no-cors" });
      } catch (sheetErr) {
        console.warn("Google Sheets log failed (non-critical):", sheetErr);
      }

      // Send to both emails in parallel
      const results = await Promise.all(
        accessKeys.map((key) =>
          fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ access_key: key, ...commonPayload }),
          }).then((res) => res.json())
        )
      );

      console.log("Web3Forms responses:", results);

      // Consider success if at least one went through
      if (results.some((r) => r.success)) {
        setSubmitted(true);
      } else {
        console.error("Web3Forms errors:", results);
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Network error:", err);
      setError("Network error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-isb-rsvp">

      {/* Back to Home */}
      <Link to="/" className="rsvp-home-link" id="rsvp-home-link">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
        Home
      </Link>

      <section className="rsvp-page">
        {/* Atmospheric fog */}
        <div className="rsvp-fog">
          <div className="rsvp-fog-orb"></div>
          <div className="rsvp-fog-orb"></div>
          <div className="rsvp-fog-orb"></div>
        </div>

        <div className="rsvp-content" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '5rem 1rem 3rem' }}>

          {/* Logo */}
          <div style={{ marginBottom: '1.5rem', animation: 'fadeInUp 0.6s ease forwards' }}>
            <img
              src={logoImg}
              alt="Mystery Mansion Logo"
              style={{
                height: 'clamp(60px, 12vw, 120px)',
                objectFit: 'contain',
                filter: 'drop-shadow(0 0 40px rgba(201, 168, 76, 0.15))',
                display: 'block',
                margin: '0 auto',
              }}
            />
          </div>

          {/* Subtitle */}
          <p style={{
            fontFamily: 'var(--font-body)',
            fontWeight: 500,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'var(--gold)',
            fontSize: 'clamp(0.65rem, 1.5vw, 0.9rem)',
            textAlign: 'center',
            marginBottom: '2rem',
            animation: 'fadeInUp 0.6s ease 0.1s backwards',
          }}>
            Exclusive ISB Alumni Experience
          </p>

          {/* Form Card */}
          <div className="rsvp-card" id="rsvp-form-card">
            {!submitted ? (
              <>
                <h1 className="rsvp-card-title">Welcome to the Mystery Mansion</h1>
                <p className="rsvp-card-subtitle">
                  RSVP below for the <strong style={{ color: 'var(--gold-light)' }}>2nd May / 3rd May</strong> game.
                </p>

                <form onSubmit={handleSubmit} id="rsvp-form">
                  <div className="rsvp-field">
                    <label className="rsvp-label" htmlFor="rsvp-name">Name</label>
                    <input
                      type="text"
                      id="rsvp-name"
                      name="name"
                      className="rsvp-input"
                      placeholder="Your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="rsvp-field">
                    <label className="rsvp-label" htmlFor="rsvp-email">ISB Email ID</label>
                    <input
                      type="email"
                      id="rsvp-email"
                      name="email"
                      className="rsvp-input"
                      placeholder="you@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="rsvp-field">
                    <label className="rsvp-label" htmlFor="rsvp-phone">Phone Number</label>
                    <input
                      type="text"
                      id="rsvp-phone"
                      name="phone"
                      className="rsvp-input"
                      placeholder="Your phone number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="rsvp-field">
                    <label className="rsvp-label" htmlFor="rsvp-attending">For which night would you like your invitation to the Mystery Mansion?</label>
                    <select
                      id="rsvp-attending"
                      name="attending"
                      className="rsvp-select"
                      value={formData.attending}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select</option>
                      <option value="Yes - 2nd May">2nd May 2026</option>
                      <option value="Yes - 3rd May">3rd May 2026</option>
                      <option value="Yes - Either date works">Either date works basis availability</option>
                    </select>
                  </div>

                  <div className="rsvp-field">
                    <label className="rsvp-label" htmlFor="rsvp-guests">Inquiry/Requests</label>
                    <input
                      type="text"
                      id="rsvp-guests"
                      name="guests"
                      className="rsvp-input"
                      placeholder="Optional"
                      value={formData.guests}
                      onChange={handleChange}
                    />
                  </div>

                  <button
                    type="submit"
                    className="rsvp-submit"
                    id="rsvp-submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="rsvp-spinner"></span>
                        Submitting…
                      </>
                    ) : (
                      "Request Invitation"
                    )}
                  </button>

                  {error && <p className="rsvp-error">{error}</p>}
                </form>
              </>
            ) : (
              <div className="rsvp-success">
                <div className="rsvp-success-icon">🕵️</div>
                <h2 className="rsvp-success-title">Request Received!</h2>
                <p className="rsvp-success-text">
                  Thank you, <strong style={{ color: 'var(--gold-light)' }}>{formData.name}</strong>.
                  We have received your response. Expect to hear from us soon with further details.
                </p>
              </div>
            )}
          </div>

          {/* Divider & Event Details */}
          <div style={{ maxWidth: '560px', width: '100%', margin: '0 auto', padding: '0 1rem' }}>
            <div className="rsvp-divider"></div>

            <div className="rsvp-ornament">⚜ ✦ ⚜</div>

            <div className="rsvp-details">
              <p className="rsvp-details-notice">
                Invitations are extended on a first-come, first-served basis,
                <br />
                with each day limited to <strong>20 guests</strong>.
              </p>

              <div className="rsvp-details-grid">
                <div className="rsvp-detail-row">
                  <span className="rsvp-detail-label">Check-in:</span>
                  <span className="rsvp-detail-value">5 PM</span>
                </div>
                <div className="rsvp-detail-row">
                  <span className="rsvp-detail-label">Game start:</span>
                  <span className="rsvp-detail-value">Undisclosed</span>
                </div>
                <div className="rsvp-detail-row">
                  <span className="rsvp-detail-label">Game end time:</span>
                  <span className="rsvp-detail-value">Midnight</span>
                </div>
              </div>


            </div>

            <div className="rsvp-ornament" style={{ marginTop: '1.5rem' }}>⚜ ✦ ⚜</div>
          </div>

        </div>
      </section>
    </div>
  );
}
